<script lang="ts">

export default {
    name: 'icon-btn',
    props: {
        variant: {
            type: String,
            default: 'icon',
        },
        name: {
            type: String,
            required: true,
        },
    },
    data() {
        const ripple: (HTMLSpanElement | null) = null;
        return {
            ripple, // To store the ripple element reference
        };
    },
    methods: {
        handleKeyDown(event: MouseEvent) {

            // Avoid multiple ripples if the key is held down

            const button = event.currentTarget;
            // @ts-ignore
            const rect = button.getBoundingClientRect();
            const waveElement = document.createElement('span');

            const size = Math.max(rect.width, rect.height);
            const x = event.clientX - rect.left - size / 2;
            const y = event.clientY - rect.top - size / 2;

            waveElement.style.width = waveElement.style.height = `${size}px`;
            waveElement.style.left = `${x}px`;
            waveElement.style.top = `${y}px`;
            waveElement.className = 'ripple-after';

            // @ts-ignore
            button.appendChild(waveElement);
            // @ts-ignore
            event.target.addEventListener('mouseup', () => this.removeRipple(waveElement));
            // @ts-ignore
            event.target.addEventListener('mouseleave', () => this.removeRipple(waveElement));
            setTimeout(() => {
                waveElement.classList.add('ripple-after-end');
            }, 500)
        },
        removeRipple(waveElement: HTMLSpanElement | null) {
            waveElement?.classList.add('ripple-after-up');
            if (waveElement?.classList.contains('ripple-after-end') && waveElement?.classList.contains('ripple-after-up')) {
                setTimeout(() => {
                    waveElement?.remove(); // Remove the ripple
                    waveElement = null; // Reset the reference
                }, 400)
            }
        },
    },
}

</script>

<template>
    <button
        @mousedown="handleKeyDown"
        :class="`variant-${variant}`"
        class="icon-btn"
        style="
            border: 1px solid var(--active-color);
            --hover-color: color-mix(in srgb, currentColor 5%, white);
            --active-color: color-mix(in srgb, currentColor 22%, white);
        "
    >
        <slot>
            <icon-svg :name="name"/>
        </slot>
    </button>
</template>

<style lang="scss">

.variant-icon {
    @apply rounded-full justify-center size-[2.4em] [&_:is(i,svg)]:!size-[1.6em];
}

.variant-text {
    @apply rounded-md px-[.5em] h-[2.4em] gap-[.2em];
}

.icon-btn {
    @apply flex items-center ripple
        hover:bg-[var(--hover-color)] focus-visible:bg-[var(--hover-color)]
        focus:outline-0 [&:not(:focus-visible)]:!border-0
        transition-colors duration-150;
}

.ripple {
    position: relative;
    overflow: hidden;
    & > *:not(.ripple-after) {
        z-index: 1;
    }
}

.ripple-after {
    position: absolute;
    border-radius: 50%;
    transform: scale(0);
    background: var(--active-color);
    animation: ripple-animation 0.5s ease-out forwards;
    pointer-events: none;
    transition: all 0.4s ease-out;
}
.ripple-after-up {
    opacity: 0 !important;
}

@keyframes ripple-animation {
    from {
        transform: scale(0);
    }
    to {
        transform: scale(2.4);
    }
}

</style>
